import {CSSProperties, useState} from 'react'
import ReactModal from 'react-modal'

import {Flex} from 'src/components/Box'
import {SmallBody} from 'src/components/text'
import SearchContent from 'src/components/SearchContent'
import {constants, zIndexes, vhHeight, theme, cssCalc} from 'src/styles'
import {containerHoverShadow} from 'src/styles/shadow'

import {SearchIcon} from './icons'
import {Action} from './Action'

const overlay: CSSProperties = {
  maxWidth: '100vw',
  backgroundColor: 'transparent',
  zIndex: zIndexes.modal,
  transform: 'translateZ(1px)',
  height: vhHeight(100),
}

const modalStyle = {
  ...containerHoverShadow,
  border: 0,
  borderRadius: 0,
  padding: 0,
  background: theme.colors.grey1,
  width: '100%',
  maxWidth: '400px',
  height: 650,
  maxHeight: cssCalc(
    vhHeight(100),
    '-',
    constants.MOBILE_HEADER_HEIGHT,
    '-',
    '1px'
  ),
} as CSSProperties

export const DesktopSearchCta = () => {
  const [searchOpen, setSearchOpen] = useState(false)
  return (
    <>
      <Action
        aria-label="search"
        onClick={() => setSearchOpen(!searchOpen)}
        data-cy="open-desktop-search"
      >
        <Flex
          backgroundColor="grey1"
          borderRadius="10px"
          px="2"
          py="1"
          alignItems="center"
        >
          <SearchIcon mr="1" width="1.25rem" />
          <SmallBody>Find content</SmallBody>
        </Flex>
      </Action>
      <ReactModal
        isOpen={searchOpen}
        onRequestClose={() => setSearchOpen(false)}
        style={{
          overlay: overlay,
          content: {
            ...modalStyle,
            top: cssCalc(constants.DESKTOP_HEADER_HEIGHT, '+', '1px'),
            borderBottomLeftRadius: '19px',
            right: 0,
            left: 'auto',
            maxHeight: vhHeight(80),
          },
        }}
      >
        <SearchContent onRequestClose={() => setSearchOpen(false)} />
      </ReactModal>
    </>
  )
}

export const MobileSearchCta = () => {
  const [searchOpen, setSearchOpen] = useState(false)
  return (
    <>
      <Action
        aria-label="search"
        onClick={() => setSearchOpen(!searchOpen)}
        data-cy="open-mobile-search"
      >
        <Flex
          px="2"
          height={constants.MOBILE_HEADER_HEIGHT}
          alignItems="center"
        >
          <SearchIcon width="1.25rem" />
        </Flex>
      </Action>
      <ReactModal
        isOpen={searchOpen}
        onRequestClose={() => setSearchOpen(false)}
        style={{
          overlay,
          content: {
            ...modalStyle,
            top: cssCalc(constants.MOBILE_HEADER_HEIGHT, '+', '1px'),
            left: '0',
          },
        }}
      >
        <SearchContent onRequestClose={() => setSearchOpen(false)} />
      </ReactModal>
    </>
  )
}
